import ChannelsList from "discourse/plugins/chat/discourse/components/channels-list";

export default <template><ChannelsList /></template>
